module.exports = __webpack_public_path__ + "static/img/123.b1df285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/123.jpg
// module id = 9RRY
// module chunks = 0